import { SelectorGranularitiesProps } from "components/admin/SelectorGranularities";
import {
  MonitoringFilters_V2,
  MonitoringGranularity,
} from "libLegacy/api/models";

export const mapTabDurationToGranularity = (
  duration: SelectorGranularitiesProps["granularity"]
): MonitoringGranularity => {
  switch (duration) {
    case "day":
      return "hourly";
    case "year":
      return "monthly";
    default:
      return "daily";
  }
};

export const formatMonitoringFetchingParams = (
  start: Date,
  end: Date,
  tabDuration: SelectorGranularitiesProps["granularity"],
  contracts: string,
  id: string
): MonitoringFilters_V2 => {
  const params = {};
  params["fromTime"] = start.toISOString().substring(0, 10);
  params["toTime"] = end.toISOString().substring(0, 10);
  params["granularity"] = mapTabDurationToGranularity(tabDuration);
  params["spaceId"] = id;

  if (contracts) {
    params["contractId"] = contracts;
  }

  return params as MonitoringFilters_V2;
};

export const UNIT_CONFIG = {
  kWh: {
    style: "decimal",
  },
  money: {
    style: "currency",
    currency: "BRL",
  },
  C02e: {
    style: "decimal",
  },
};
